/**
 * MobileHomeIndicator — the iOS home-indicator bar at the very bottom of a
 * tablet / mobile page frame. The top device chrome now lives in the fused
 * PageTitleBar (the browser/status bar became the page's titlebar); this is the
 * one remaining device cue that sits below the page content.
 * react-strict-dom (html.* + css.create).
 */
import { html, css } from "react-strict-dom";
import { colors } from "@duro-app/tokens/tokens/colors.css";
import { sizes } from "@duro-app/tokens/tokens/sizes.css";
import {
  spacing,
  microSpacing,
  radii,
} from "@duro-app/tokens/tokens/spacing.css";

const s = css.create({
  homeWrap: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingTop: microSpacing.px6,
    paddingBottom: spacing.sm,
    backgroundColor: colors.fixedLight,
  },
  homeBar: {
    width: sizes.deviceBarW,
    height: sizes.barH,
    borderRadius: radii.full,
    backgroundColor: colors.border,
  },
});

/** The iOS home-indicator bar at the very bottom of a tablet / mobile page. */
export function MobileHomeIndicator() {
  return (
    <html.div aria-hidden style={s.homeWrap}>
      <html.span style={s.homeBar} />
    </html.div>
  );
}
